import $ from 'jquery'
import _ from 'lodash'
import { createLeadAssistant } from '@quero/qb-partials/src/javascripts/components/lead_assistant'

$careerNavLinkWrapper = $('.js-careers-page__nav-links-wrapper')
$navbarSubmenu = $('.js-navbar-submenu')
$navbarLinks = $('#navbar')
$container = $('.container')

adjustLinksWrapperNav = ->
  $careerNavLinkWrapper.width(($container.outerWidth() * .33333333333)-30)

scrollToElement = (elt) ->
  $('html, body').animate
    scrollTop: elt.offset().top - 100, 300

changeActiveNavLink = ->
  $('.career-nav-links__link-anchor--active').removeClass('career-nav-links__link-anchor--active')
  $('.career-nav-links__link-anchor', '.active').addClass('career-nav-links__link-anchor--active')

$('.nav.navbar-nav a, .js-career-nav__link').on 'click', (e)->
  e.preventDefault()
  element = $(this)
  $navbarLinks.removeClass('in')
  selector = element.attr('href')
  $('.career-nav-links__link-anchor--active').removeClass('career-nav-links__link-anchor--active')
  if element.hasClass('career-nav-links__link-anchor')
    element.addClass('career-nav-links__link-anchor--active')
  scrollToElement($(selector))

$careerNavLinkWrapper.on 'activate.bs.scrollspy', _.debounce((->
  changeActiveNavLink()
  ), 250)

$(window).on 'resize', _.debounce((->
  adjustLinksWrapperNav()
  ), 250)
adjustLinksWrapperNav()
changeActiveNavLink()

_require [
  'bootstrap/scrollspy',
  'bootstrap/affix'
], ->
  $('body').scrollspy
    target: '.js-careers-page__nav-links-wrapper'
    offset: $('#js-scroll-spy-wrapper').outerHeight()/2

  $careerNavLinkWrapper.affix
    offset:
      top: $('.js-header').outerHeight(true) + $navbarSubmenu.outerHeight(true),
      bottom: ->
        this.bottom = $('.bottom-body').outerHeight(true) + parseInt($('.careers-page__courses_items-wrapper').css('margin-bottom'))

createLeadAssistant()
